// dev-topbar — announcement bar rotator.
//
// Enhances <dev-topbar-ticker> (the center of sections/dev-topbar.liquid). With a
// single announcement it does nothing — the item just sits inline. With 2+ items
// it stacks them (via the .dev-topbar__promo--ticker class, styled in
// dev-topbar.css) and crossfades through them on an interval. Progressive
// enhancement: without this script, or with prefers-reduced-motion, all items
// simply render inline / the first is shown — no message is ever hidden with no
// way to reach it.

(function () {
  'use strict';

  if (customElements.get('dev-topbar-ticker')) return;

  customElements.define('dev-topbar-ticker', class extends HTMLElement {
    #items = [];
    #index = 0;
    #timer = null;
    #stop = null;

    connectedCallback() {
      this.#items = Array.from(this.querySelectorAll('[data-topbar-item]'));
      if (this.#items.length <= 1) return; // one message: nothing to rotate

      // Items are stacked one-at-a-time by CSS; the first is already .is-active
      // (marked server-side, so no flash). Normalise in case markup drifted.
      this.#items.forEach((el, i) => el.classList.toggle('is-active', i === 0));

      const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = this.dataset.autoplay === 'true';
      if (!autoplay || reduce) return; // stays on the first message, no motion

      const speed = Math.max(2, Number(this.dataset.speed) || 5) * 1000;
      const start = () => { if (!this.#timer) this.#timer = setInterval(() => this.#advance(), speed); };
      const stop = () => { if (this.#timer) { clearInterval(this.#timer); this.#timer = null; } };
      this.#stop = stop;

      // Pause while the shopper is reading (hover) or tabbing through a link.
      this.addEventListener('mouseenter', stop);
      this.addEventListener('mouseleave', start);
      this.addEventListener('focusin', stop);
      this.addEventListener('focusout', start);
      start();
    }

    disconnectedCallback() {
      if (this.#stop) this.#stop();
    }

    #advance() {
      this.#items[this.#index].classList.remove('is-active');
      this.#index = (this.#index + 1) % this.#items.length;
      this.#items[this.#index].classList.add('is-active');
    }
  });
})();
